import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAI from './ai.reducer';

const selectRegisteredAIState = createFeatureSelector<fromAI.State | undefined>(fromAI.aiFeatureKey);

/**
 * The initial state until AIStoreModule registers the feature. The global assistant in the core's
 * header bar reads this store on every screen of every host; a host (or its AppComponent spec) that
 * never loads the AI module must still render the bar.
 */
export const selectAIState = createSelector(selectRegisteredAIState, (s): fromAI.State => s ?? fromAI.initialState);

export const selectAILoading = createSelector(selectAIState, (s) => s.loading);
export const selectHttpResult = createSelector(selectAIState, (s) => s.httpResult);
export const selectConversationId = createSelector(selectAIState, (s) => s.conversationId);
export const selectMessages = createSelector(selectAIState, (s) => s.messages);
export const selectConversations = createSelector(selectAIState, (s) => s.conversations);
export const selectGeneratedQueryConfig = createSelector(
  selectAIState,
  (s) => s.generatedQueryConfig
);
export const selectGeneratedChartConfig = createSelector(
  selectAIState,
  (s) => s.generatedChartConfig
);
export const selectSuggestions = createSelector(selectAIState, (s) => s.suggestions);
export const selectAvailableModels = createSelector(selectAIState, (s) => s.availableModels);
export const selectSelectedModel = createSelector(selectAIState, (s) => s.selectedModel);
export const selectDefaultModel = createSelector(selectAIState, (s) => s.defaultModel);
export const selectThinkingLevels = createSelector(selectAIState, (s) => s.thinkingLevels);
export const selectSqlFirst = createSelector(selectAIState, (s) => s.sqlFirst);
export const selectModelSelectorEnabled = createSelector(selectAIState, (s) => s.modelSelectorEnabled);
export const selectSelectedThinkingLevel = createSelector(
  selectAIState,
  (s) => s.selectedThinkingLevel
);
export const selectSessionRating = createSelector(selectAIState, (s) => s.sessionRating);
export const selectCancelledMessage = createSelector(selectAIState, (s) => s.cancelledMessage);
export const selectFailedMessage = createSelector(selectAIState, (s) => s.failedMessage);
export const selectFailedQueryConfig = createSelector(selectAIState, (s) => s.failedQueryConfig);
export const selectFailedChartConfig = createSelector(selectAIState, (s) => s.failedChartConfig);
export const selectFailedContext = createSelector(selectAIState, (s) => s.failedContext);
export const selectFailedErrorCode = createSelector(selectAIState, (s) => s.failedErrorCode);
export const selectFailedErrorDetail = createSelector(selectAIState, (s) => s.failedErrorDetail);
